import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { UnitOfServiceRecord } from '../models/unit-of-service-record.model';

@Injectable({
    providedIn: 'root'
  })
export class UnitOfServiceRecordService {
    readonly apiServer: string;

    constructor(private _configService: ConfigService, private _http: HttpClient) { 
        this.apiServer = this._configService.appSettings.webApiServer  + "api/UnitOfServiceRecord/";
    }

    public async getUnitOfServiceRecordsForAncillaryPatient(costCenterId: number, workflowTimeFacilities: Date[]): Promise<UnitOfServiceRecord[]> {
        return await this._http.post<UnitOfServiceRecord[]>(`${this.apiServer}GetUnitOfServiceRecordsForAncillaryPatient/${costCenterId}`, workflowTimeFacilities).toPromise<UnitOfServiceRecord[]>();
    }

    async getUnitOfServiceRecords(costCenterId: number, facilityWorkflowDates: Date[]): Promise<UnitOfServiceRecord[]> {
        return await this._http.post<UnitOfServiceRecord[]>(`${this.apiServer}GetUnitOfServiceRecords/${costCenterId}`, facilityWorkflowDates).toPromise<UnitOfServiceRecord[]>();
    }

    saveUnitOfServiceRecords(uosRecords: UnitOfServiceRecord[], costCenterId: number) {
        if (uosRecords){
            return this._http.post<boolean>(`${this.apiServer}SaveUnitOfServiceRecords/${costCenterId}`, uosRecords).toPromise<boolean>();
        }        
    }
}